<template>
    <div class="main-container">
        <!-- 页面标题 -->
        <div class="page-header">
            <h1 class="page-title">监督详情</h1>
        </div>
        <div class="content">
          <a-form
            :form="form"
            @submit="handleSubmit"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 18 }"
            :colon="false"
          >
            <a-row>
              <a-col :lg="24" :md="24" :sm="24">
                  <TextareaField :modelValue="text.content" disabled labelWidth="10%" style="margin: 0.5rem 0.2rem" label="上报内容"
                                 @update:modelValue="(value) => handleModelValueUpdate('content', value)"
                  />
              </a-col>
              <a-col :lg="12" :md="12" :sm="24">
                  <InputField disabled labelWidth="25%" label="上报人联系方式" type="text" id="reporterContact"
                              :modelValue="text.reporterContact" placeholder="上报人联系方式"
                              @update:modelValue="(value) => handleModelValueUpdate('reporterContact', value)"
                  />
              </a-col>
              <a-col :lg="12" :md="12" :sm="24">
                  <InputField disabled labelWidth="25%" label="上报时间" type="text" id="reporteTime"
                              :modelValue="text.reporteTime" placeholder="上报时间"
                              @update:modelValue="(value) => handleModelValueUpdate('reporteTime', value)"
                  />
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                  <div class="form-group">
                      <label class="form-label">
                          <span style="visibility: hidden;">*</span>
                         图片
                      </label>
                      <img width="200px" :src="item" alt v-for=" (item, index) in imgList" :key="index" style="margin:10px"/>
                  </div>
              </a-col>
              <a-col :lg="12" :md="12" :sm="24">
                  <SelectField labelWidth="25%" label="处理状态" required :options="statusList"
                               :modelValue="text.status" id="status" placeholder="处理状态"
                               @update:modelValue="(value) => handleModelValueUpdate('status', value)"
                  />
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                  <TextareaField :modelValue="text.remark" required labelWidth="10%" style="margin: 0.5rem 0.2rem" label="处理说明"
                                 @update:modelValue="(value) => handleModelValueUpdate('remark', value)"
                  />
              </a-col>
              <a-col :lg="12" :md="12" :sm="24">
                  <InputField labelWidth="25%" label="处理人" type="text" id="processor"
                              :modelValue="text.processor" placeholder="处理人"
                              @update:modelValue="(value) => handleModelValueUpdate('processor', value)"
                  />
              </a-col>

              <a-col :lg="12" :md="12" :sm="24">
                    <DatePickerField labelWidth="25%" format="YYYY-MM-DD HH:mm:ss" label="处理时间" required name="consumeTime"
                                     placeholder="请选择日期" :rules="[{ required: true, message: '请选择日期' }]"
                                     :modelValue="text.processTime"
                                     @update:modelValue="(value) => handleModelValueUpdate('processTime', value)"/>
              </a-col>
            </a-row>

            <div class="center">
              <a-space>
                  <ButtonField text="关闭" @click="cancel" secondary />
                  <ButtonField text="保存" primary @click="handleSubmit"/>
              </a-space>
            </div>
          </a-form>
        </div>
    </div>
</template>

<script>
import { fetchDetail, edit } from "@/api/supervise";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      form: {
          content:null,
          reporterContact:null,
          reporteTime:null,
          status:null,
          remark:null,
          processTime:null,
      },
      userList: [],
      text: {},

      id: "",
      imgList: [], //图片列表
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),

    statusList() {
      return this.findDataDict("superviseStatus");
    },
  },

  mounted() {
    const { id } = this.$route.query;
    if (!id) {
      return;
    }

    this.id = id || "";
    this.getDetail();
  },

  methods: {
    handleModelValueUpdate(fieldName, value) {
        this.form[fieldName] = value;
    },
    moment,
    getDetail() {
      fetchDetail({ id: this.id }).then((res) => {
        if (!res.id) {
          return;
        }

        this.text = {
          ...res,
        };
        console.log("this.text:",this.text)

        if (res.pictures) {
          this.imgList = res.pictures
            .split(",")
            .map((item) => "http://" + item);
        }

        if (res.processTime) {
          this.form.setFieldsValue({
            processTime: moment(res.processTime),
          });
        }
      });
    },
    cancel() {
      this.$router.go(-1);
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          edit({
            id: this.id,
            ...values,
            processTime: values.processTime.format("YYYY-MM-DD HH:mm:ss"),
          }).then(() => {
            this.$router.go(-1);
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/* 主内容区 */
.main-container {
  padding:2rem 0;
  width: 80%;
  margin: auto;
}

/* 页面标题 */
.page-header {
  margin-bottom: 2rem;
}

.page-title {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #fff, #00ff96);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.content{
  background: rgba(20, 35, 70, 0.5);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 255, 150, 0.2);
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 1.5rem;
}
.center {
  margin: 60px 0 20px;
}
.form-group {
  display: flex;
  align-items: center;
  width: 100%;
  padding:0.2rem 0;
}

.form-label {
  display: block;
  color: #94a3b8;
  font-size: 0.9rem;
  width: 40%;
  white-space: nowrap;
  margin-right: 0.5rem;
}
</style>
